import axios from "axios";
const httpClientlikes = axios.create({
  baseURL: process.env.REACT_APP_URL_CORE_ENGINE,
  timeout: 36000,
});
let count = 0;

httpClientlikes.interceptors.request.use(
  function (config) {
    count++;
    if (document.getElementById("cv-loader")) {
      document.getElementById("cv-loader").style.display = "block";
    }
    // Do something before request is sent
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    if (document.getElementById("cv-loader")) {
      document.getElementById("cv-loader").style.display = "none";
    }
    count--;
    return Promise.reject(error);
  }
);

httpClientlikes.interceptors.response.use(
  function (response) {
    count--;
    if (count === 0) {
      if (document.getElementById("cv-loader")) {
        document.getElementById("cv-loader").style.display = "none";
      }
    }
    return response;
  },
  function (error) {
    if (error.response) {
      if (
        error.response.status === 401 &&
        window.location.pathname !== "/"
      ) {
        localStorage.removeItem("auth_token");
      }
      count--;
    } else if (error.request) {
      count--;
    } else {
      count--;
    }
    if (document.getElementById("cv-loader")) {
      document.getElementById("cv-loader").style.display = "none";
    }
    return Promise.reject(error);
  }
);

export default httpClientlikes;
